import React, { useEffect, useState } from "react";
import api from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
 import "../style/passbook.css";


const CustomerSearch = ({ onSelectCustomer }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [customers, setCustomers] = useState([]);

  // 🔥 Call API
  const searchCustomers = async (name) => {
    if (!name) {
      setCustomers([]);
      return;
    }

    try {
      const response = await api.get(
        "/customers/searchCustomers",
        {
          params: { name: name }
        }
      );

      setCustomers(response.data || []);
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  // 🔥 Debounce (500ms delay)
  useEffect(() => {
    const timer = setTimeout(() => {
      searchCustomers(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleSelect = (customer) => {
    setSearchTerm(customer.name);
    setCustomers([]);
    onSelectCustomer(customer); // send full object to Passbook
  };

    
  return (
  <div className="customer-search">
    <label>Customer</label>

    <div className="dropdown-container">
      <div className="customer-input-wrapper">
        <input
          type="text"
          placeholder="Search customer..."
          value={searchTerm} 
          onChange={(e) => {
            setSearchTerm(e.target.value);
            onSelectCustomer(null);
          }}
          className="customer-input"
        />
      </div>

      {customers.length > 0 && (
        <div className="dropdown-list">
          {customers.map((customer) => (
            <div
              key={customer.id}
              className="dropdown-item"
              onClick={() => handleSelect(customer)}
            >
              <div className="customer-name">{customer.name}</div>
              <div className="customer-contact">
                {customer.contactNumber || 'No contact'}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);
};

export default CustomerSearch;
